import {Inject, Injectable} from "@angular/core";
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpStatusCode,
} from "@angular/common/http";
import {catchError, Observable, throwError} from "rxjs";
import {SFTPConnectionService} from "@app/services/sftp-connection.service";
import {AuthorizationService} from "@app/services/authorization.service";
import {SFTPMainPages} from "@app/modules/models";
import {WINDOW} from "@app/services/window.service";

@Injectable()
export class AuthorizationInterceptor implements HttpInterceptor {
  constructor(
    private sftpConnectionService: SFTPConnectionService,
    private authorizationService: AuthorizationService,
    @Inject(WINDOW) private window: Window
  ) {}

  intercept(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    request: HttpRequest<any>,
    next: HttpHandler
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ): Observable<HttpEvent<any>> {
    if (this.isApiRequest(request)) {
      return next.handle(request).pipe(
        catchError((error) => {
          return this.handleResponseError(error);
        })
      );
    }

    return next.handle(request);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private handleResponseError(error): Observable<HttpEvent<any>> {
    if (error instanceof HttpErrorResponse) {
      if (error.status === HttpStatusCode.Unauthorized) {
        if (this.sftpConnectionService) {
          this.sftpConnectionService.disableConnection();
        }

        if (this.authorizationService) {
          this.authorizationService.userAuthorized = false;
        }

        if (!this.window.location.pathname.startsWith(`/${SFTPMainPages.login}`)) {
          this.window.location.replace(`/${SFTPMainPages.login}`);
        }
      }
    }

    return throwError(error);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private isApiRequest(request: HttpRequest<any>): boolean {
    return request.url.startsWith("/api/");
  }
}
